import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {
  /** @default 'outlined' */
  variant?: 'outlined' | 'filled';
}

const ZoomUsIcon = ({ variant = 'outlined', ...props }: Props) => {
  return (
    <SvgIcon
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_105_1680)">
        <path
          d="M18.0546 0H5.94539C2.66184 0 0 2.66184 0 5.94539V18.0546C0 21.3382 2.66184 24 5.94539 24H18.0546C21.3382 24 24 21.3382 24 18.0546V5.94539C24 2.66184 21.3382 0 18.0546 0Z"
          fill="#2D8CFF"
        />
        <path
          d="M5 8.77418C5 8.34661 5.34662 8 5.77419 8H13.5464C14.6865 8 15.6109 8.92431 15.6109 10.0645V15.6119C15.6109 16.0393 15.2643 16.3861 14.8367 16.3861H7.06453C5.92432 16.3861 5 15.4617 5 14.3215V8.77418Z"
          fill="white"
        />
        <path
          d="M16.2954 10.6361C16.2954 10.4839 16.3626 10.3394 16.4792 10.2413L18.6986 8.37233C19.0343 8.08966 19.5472 8.32828 19.5472 8.76711V15.6821C19.5472 16.1247 19.0268 16.3619 18.6926 16.0717L16.4732 14.1444C16.3603 14.0463 16.2954 13.9041 16.2954 13.7546V10.6361Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_105_1680">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default ZoomUsIcon;
